import { UploadedFile } from './types';

export const ACTIVATE_TRADING_HISTORY = 'page/TRADING_HISTORY [activate]';
export const TRADING_HISTORY_READY = 'page/TRADING_HISTORY [ready]';
export const TRADING_HISTORY_LOADING = 'page/TRADING_HISTORY [loading]';
export const TRADING_HISTORY_ERROR = 'page/TRADING_HISTORY [error]';

export const CUSTOMER_CONFIRMED_DOCS = 'api/CUSTOMER_CONFIRMED_DOCS';
export const CUSTOMER_CONFIRMED_DOCS_SUCCESS =
    'api/CUSTOMER_CONFIRMED_DOCS [success]';
export const CUSTOMER_CONFIRMED_DOCS_ERROR =
    'api/CUSTOMER_CONFIRMED_DOCS [error]';
export const UPLOAD_DOCS = 'api/UPLOAD_DOCS';
export const UPLOAD_DOCS_SUCCESS = 'api/UPLOAD_DOCS [success]';
export const UPLOAD_DOCS_ERROR = 'api/UPLOAD_DOCS [error]';
export const REMOVE_UPLOAD_DOCS_ALERT = 'page/REMOVE_UPLOAD_DOCS_ALERT';
export const UPLOAD_DOCS_LOADING = 'api/UPLOAD_DOCS [loading]';
export const FETCH_UPLOADED_DOCS = 'api/FETCH_UPLOADED_DOCS';
export const REMOVE_ERRORED_DOC = 'page/REMOVE_ERRORED_DOC';
export const TRADING_HISTORY_DOC_STATUS = 'page/TRADING_HISTORY_DOC_STATUS';
export const UPDATE_TRADING_HISTORY_DOC_STATUS =
    'page/UPDATE_TRADING_HISTORY_DOC_STATUS';

export const TRADING_HISTORY_NO_LOAN_DECISION =
    'page/TRADING_HISTORY_NO_LOAN_DECISION';

export const HANDLE_TRADING_HISTORY_DOC_SUBMIT =
    'HANDLE_TRADING_HISTORY_DOC_SUBMIT';

export const HANDLE_TRUE_LAYER_LINKED = 'HANDLE_TRUE_LAYER_LINKED';
export const TRUELAYER_LINKED_LOADING = 'TRUELAYER_LINKED_LOADING';
export const TRUELAYER_LINKED_COMPLETE = 'TRUELAYER_LINKED_COMPLETE';
export const TRUELAYER_LINKED_ERROR = 'TRUELAYER_LINKED_ERROR';
export const ADD_VAT_MISSING_DOCS = 'ADD_VAT_MISSING_DOCS';
export const REMOVE_VAT_MISSING_DOCS = 'REMOVE_VAT_MISSING_DOCS';

export const activate = () => ({ type: ACTIVATE_TRADING_HISTORY });
export const uploadDocuments = (documents: FileList, documentType: string) => ({
    type: UPLOAD_DOCS,
    documents,
    documentType
});

export const removeRejectedFile = (file: UploadedFile) => ({
    type: REMOVE_ERRORED_DOC,
    file: file
});
